export function removeFromArray<T>(arr: Array<T>, item: T) {
	const index = arr.indexOf(item);
	if (index > -1) {
		arr.splice(index, 1);
	}
}

export function joinStrings(arr: Array<string>) {
	return arr.reduce((acc: string, curr: string, index: number) => {
		if (index === arr.length - 1) {
			return acc + curr;
		}

		if (index === arr.length - 2) {
			return `${acc + curr} og `;
		}

		return `${acc + curr}, `;
	}, '');
}
